import { Switch } from '@components';
import { isAllowed } from '@helpers/auth';
import { useBankAccount, useBreakpoint } from '@hooks';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

const Container = styled.div(
  ({ theme }) => `
    display: flex;
    width: calc(100% - 16px);
    height: 120px;
    background-color: white;
    flex-direction: row;
    padding: 32px;
    align-items: center;
    ${theme.breakpoint('md')} {
      width: 500px;
    }
  `
);

const TextContainer = styled.div(
  ({ theme }) => `
  ${theme.breakpoint('md')} {
    padding-right: 96px;
  }
`
);

const ContainerTitle = styled.div(
  ({ theme }) => `
    display: flex;
    justify-content: space-between;
    font-family: Roboto;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.36;
    letter-spacing: normal;
    text-align: left;
    padding-bottom: ${theme.breakpoint('md') ? '4px' : '16px'};
    color: ${theme.colors.gray800};
  `
);

const ContainerDescription = styled.div(
  ({ theme }) => `
    font-family: Roboto;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: normal;
    text-align: left;
    color: ${theme.colors.gray800};
  `
);

const AutomaticFundsTranfer = ({ bankAccount }) => {
  const { t } = useTranslation();
  const { updateAutoCashout } = useBankAccount();
  const { mobile } = useBreakpoint();
  const { auto_cashout: autoCashout } = useSelector((state) => state.login.merchant);

  const showContainer = isAllowed('WITHDRAW_RECURRENT') && !!bankAccount;
  const handleSwitchChange = () => {
    updateAutoCashout();
  };

  return (
    showContainer && (
      <Container>
        <TextContainer>
          <ContainerTitle data-testid="automatic-funds-transfer_title">
            {t('paymentsFoundsOut.automaticFundsTransfer.title')}
            {mobile && <Switch active />}
          </ContainerTitle>
          <ContainerDescription data-testid="automatic-funds-transfer_description">
            {t('paymentsFoundsOut.automaticFundsTransfer.description')}
          </ContainerDescription>
        </TextContainer>
        {!mobile && (
          <Switch
            active={autoCashout}
            onChange={handleSwitchChange}
            dataTestid="automatic-funds-transfer_switch"
          />
        )}
      </Container>
    )
  );
};

export default AutomaticFundsTranfer;
